const EntryTypesEnum = Object.freeze({
    FULL: 'full',
    SHORT: 'short',
    SHORTSHORT: 'shortshort',
    NONE: 'none',
});

export default EntryTypesEnum;